export const pathPrefix = '/web';

export const formLayout = {
  labelCol: {
    sm: { span: 6, offset: 0 },
    xs: { span: 24, offset: 0 },
  },
};

export const itemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  }
};

export const formItemLayoutWithOutLabel = {
  wrapperCol: {
    span: 18,
    offset: 6,
  }
};

export const authorizeAttribute = {
  business: "商用永久",
  temporary: "临时授权",
};

export const attributeList = [
  {
    title: "商用永久",
    value: "business",
  },
  {
    title: "临时授权",
    value: "temporary",
  }
];

export const EDIT_TYPE = {
  EDIT: 'EDIT',
  ADD: 'ADD',
};

export const accountCategory = {
  /** 内部账号，管理员 */
  ADMIN: { value: 'ADMIN', desc: '管理员' },
  PRODUCT_MANAGER: { value: 'PRODUCT_MANAGER', desc: '产品经理' },

  /** 内部账号，渠道经理 */
  CHANNEL_MANAGER: { value: 'CHANNEL_MANAGER', desc: '渠道经理' },
  SALE: { value: 'SALE', desc: '销售' },
  PRESALE: { value: 'PRESALE', desc: '售前' },
  DIRECTOR: { value: 'DIRECTOR', desc: '主任' },
  TECHNICAL_SUPPORT: { value: 'TECHNICAL_SUPPORT', desc: '技术支持' },
  ACCOUNT_MANAGER: { value: 'ACCOUNT_MANAGER', desc: '客户经理' },
  BUSINESS_OWNER: { value: 'BUSINESS_OWNER', desc: '业务负责人' },

  /** 外部账号 */
  AGENT: { value: 'AGENT', desc: '代理商' },
  AGENT_CHILD: { value: 'AGENT_CHILD', desc: '代理商子账号' },
};

export const adminAccountList = [
  {
    value: 'ADMIN',
    title: "管理员"
  },
  {
    value: 'PRODUCT_MANAGER',
    title: "产品经理"
  },
];

export const agentAccountList = [
  {
    value: 'AGENT',
    title: "代理商"
  },
  {
    value: 'AGENT_CHILD',
    title: "代理商子账号"
  },
];

export const accountList = [
  {
    value: 'CHANNEL_MANAGER',
    title: "渠道经理"
  },
  {
    value: 'SALE',
    title: "销售"
  },
  {
    value: 'PRESALE',
    title: "售前"
  },
  {
    value: 'DIRECTOR',
    title: "主任"
  },
  {
    value: 'TECHNICAL_SUPPORT',
    title: "技术支持"
  },
  {
    value: 'ACCOUNT_MANAGER',
    title: "客户经理"
  },
  {
    value: 'BUSINESS_OWNER',
    title: "业务负责人"
  },
];

export const allAuditStatus = {
  NEW: { value: 'NEW', desc: '未发布' },
  ACTIVE: { value: 'ACTIVE', desc: '已发布' },
  INACTIVE: { value: 'INACTIVE', desc: '已下架' },
  CLOSE: { value: 'CLOSE', desc: '已撤销' },
  CREATE_ING: { value: 'CREATE_ING', desc: '发布审批中' },
  CREATE_AUDIT: { value: 'CREATE_AUDIT', desc: '发布审批中' },
  CREATE_REJECT: { value: 'CREATE_REJECT', desc: '发布不通过' },
  UPDATE_AUDIT: { value: 'UPDATE_AUDIT', desc: '修改审批中' },
  CLOSE_AUDIT: { value: 'CLOSE_AUDIT', desc: '关闭审批中' },
  CREATE_CLOSE: { value: 'CREATE_CLOSE', desc: '上报不通过' },

  /** 表单中不显示这些状态，但是历史记录中有 */
  UPDATE_REJECT: { value: 'UPDATE_REJECT', desc: '修改不通过' },
  CLOSE_REJECT: { value: 'CLOSE_REJECT', desc: '下架不通过' },
  CREATE_PASS: { value: 'CREATE_PASS', desc: '发布通过' },
  UPDATE_PASS: { value: 'UPDATE_PASS', desc: '修改通过' },
  CLOSE_PASS: { value: 'CLOSE_PASS', desc: '下架通过' },
  TOP_UPDATE: { value: 'TOP_UPDATE', desc: '置顶更新' },
  DOWN_UPDATE: { value: 'DOWN_UPDATE', desc: '取消置顶更新' },
  UPDATE: { value: 'UPDATE', desc: '更新' },
  REVOKE: { value: 'REVOKE', desc: '撤回' },
  RECOVERY_AUDIT: { value: 'RECOVERY_AUDIT', desc: '上报恢复' },
  RECOVERY_REJECT: { value: 'RECOVERY_REJECT', desc: '恢复驳回' },
  RECOVERY_PASS: { value: 'RECOVERY_PASS', desc: '恢复' },
};

export const releaseStatus = {
  DRAFT: { value: 'DRAFT', desc: '草稿' },
  CREATE: { value: 'CREATE', desc: '创建' },
  EDIT: { value: 'EDIT', desc: '修改' },
  ING: { value: 'ING', desc: '审批中' },
  REJECT: { value: 'REJECT', desc: '驳回' },
  DISAGREE: { value: 'DISAGREE', desc: '不同意' },
  AGREE: { value: 'AGREE', desc: '同意' },
  REVOKE: { value: 'REVOKE', desc: '撤回' },
};

export const customerState = {
  DRAFT: { value: 'DRAFT', text: '草稿', color: 'default' },
  CREATE: { value: 'CREATE', text: '创建审批中', color: 'processing' },
  EDIT: { value: 'EDIT', text: '编辑审批中', color: 'processing' },
  REJECT: { value: 'REJECT', text: '驳回', color: 'error' },
  AGREE: { value: 'AGREE', text: '审批通过', color: 'success' },
};

export const solutionStatusList = [
  {
    value: "CREATE",
    title: "未发布"
  },
  {
    value: "ACTIVE",
    title: "已发布"
  },
  {
    value: "INACTIVE",
    title: "已下架"
  },
  {
    value: "CREATE_AUDIT",
    title: "发布审批中"
  },
  {
    value: "CREATE_REJECT",
    title: "发布不通过"
  },
  {
    value: "UPDATE_AUDIT",
    title: "修改审批中"
  },
  {
    value: "CLOSE_AUDIT",
    title: "下架审批中"
  },
];

export const projectChangeType = {
  NEW: { value: 'NEW', desc: '新产品上市' }, // 新产品上市
  OLD: { value: 'OLD', desc: '老产品退市' }, // 老产品退市
  PRICE_CHANGE: { value: 'PRICE_CHANGE', desc: '产品价格调整' }, // 产品价格调整
  PROMOTION: { value: 'PROMOTION', desc: '产品促销' }, // 产品促销
  MAJOR_UPGRADE: { value: 'MAJOR_UPGRADE', desc: '产品重大升级' }, // 产品重大升级
};

/**
 * 文件格式
 */
export const docFormat = {
  PDF: { value: 'PDF', desc: 'PDF' },
  DOC: { value: 'DOC', desc: 'DOC' },
  DOCX: { value: 'DOCX', desc: 'DOCX' },
  PPT: { value: 'PPT', desc: 'PPT' },
  PPTX: { value: 'PPTX', desc: 'PPTX' },
  XLS: { value: 'XLS', desc: 'XLS' },
  XLSX: { value: 'XLSX', desc: 'XLSX' },
  IMAGE: { value: 'IMAGE', desc: '图片' },
  OTHER: { value: 'OTHER', desc: '其他文件' },
};

/**
 * 确认格式（授权模块会使用到这些文件）
 */
export const correctFileExt = ['xlsx', 'xls'];

/**
 * 确认格式(报价发布)
 */
export const quotationCorrectFileExt = ['pdf', 'doc'];

/**
 * 全局的资料的后缀名校验(资料、解决方案、成功案例会用到这些格式的文件)
 */
export const globalCorrectFileExt = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xlsx', 'xls'];

/**
 * 常见图片后缀名
 */
export const commonImage = ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'svg'];


/**
 * 权限类型
 */
export const rightType = {
  READ: { value: 'READ', desc: '仅预览' },
  DOWNLOAD: { value: 'DOWNLOAD', desc: '可下载' },
  SHARE: { value: 'SHARE', desc: '可分享' },
};

/**
 * 权限类型
 */
export const faqRightType = {
  READ: { value: 'READ', desc: '仅预览' },
  SHARE: { value: 'SHARE', desc: '可分享' },
};

/**
 * 资料状态
 */
export const docStatus = {
  DRAFT: { value: 'DRAFT', desc: '草稿' },
  AUDIT_ING: { value: 'AUDIT_ING', desc: '审批中' },
  UP: { value: 'UP', desc: '上架' },
  DOWN: { value: 'DOWN', desc: '下架' },
};

/**
 * 提交类型
 */
export const submitType = {
  DRAFT: 'DRAFT',
  FORMAL: 'FORMAL',
  UPDATE: 'UPDATE',
};

/**
 * 成功案例和解决方案
 */

export const productCase = {
  SUCCCASE: { value: "SUCCCASE", desc: "成功案例" },
  SOLUTION: { value: "SOLUTION", desc: "解决方案" },
};

export const searchContentKey = {
  DOC: { value: "DOC", title: "资料中心", path: pathPrefix + "/main/data/center" },
  PRODUCT_NOTICE: { value: "PRODUCT_NOTICE", title: "通知", path: pathPrefix + "/main/product-change" },
  SOLUTION: { value: "SOLUTION", title: "解决方案", path: pathPrefix + "/main/solution/detail" },
  SUCCCASE: { value: "SUCCCASE", title: "成功案例", path: pathPrefix + "/main/solution/detail" },
  FAQ: { value: "FAQ", title: "FAQ", path: pathPrefix + "/main/faq/center" },
};

/**
 * 审批单据的状态
 */
export const todoListStatus = {
  ING: { value: "ING", title: "我的待办列表" },
  APPROVED: { value: "APPROVED", title: "已审批" },
  LAUNCH: { value: "LAUNCH", title: "我发起的" },
};

/**
 * 软件属性
 */
export const softwareReleaseType = {
  PATCH: { value: "PATCH", text: "补丁" },
  VERSION: { value: "VERSION", text: "版本" },
  MANUAL: { value: "MANUAL", text: "手册" },
};

export const softwareVersionReleaseState = {
  TECHNICAL_SUPPORT_FILLING_FORM: { value: 'TECHNICAL_SUPPORT_FILLING_FORM', text: '技术支持填单' },
  PRODUCT_MANAGER_APPROVAL: { value: 'PRODUCT_MANAGER_APPROVAL', text: '产品经理审批' },
  TECHNICAL_SUPPORT_MANAGER_APPROVAL: { value: 'TECHNICAL_SUPPORT_MANAGER_APPROVAL', text: '技术支持部经理审批' },
  PUBLISHED: { value: 'PUBLISHED', text: '已发布' },
  DEACTIVATED: { value: 'DEACTIVATED', text: '已停用' },
};

export const operatorList = [
  {
    value: '移动',
    label: '移动',
  },
  {
    value: '联通',
    label: '联通',
  },
  {
    value: '电信',
    label: '电信',
  },
];

export const seqNumberEnum = {
  customer: 'KH',
  customerProject: 'XM',
  customerQuotation: 'BJ',
};

/** 报价单状态 */
export const quotationState = {
  FORMAL: { value: 'FORMAL', text: '正式' },
  DRAFT: { value: 'DRAFT', text: '草稿' },
  REJECT: { value: 'REJECT', text: '驳回' },
  CREATE_AUDIT: { value: 'CREATE_AUDIT', text: '添加审批' },
  EDIT_AUDIT: { value: 'EDIT_AUDIT', text: '编辑再发起审批' },
  MOVE_AUDIT: { value: 'MOVE_AUDIT', text: '移动到草稿审批' },
};

export const AUTH_CONFIG_TOOL = {
  PBX: { value: 'PBX', title: 'PBX' },
  MCU: { value: 'MCU', title: 'MCU' },
  POL_NCE: { value: 'POL_NCE', title: 'POL_NCE' },
  POL_OLT: { value: 'POL_OLT', title: 'POL_OLT' },
  CDRS: { value: 'CDRS', title: 'CDRS' },
  SVR: { value: 'SVR', title: 'SVR' },
  TELECONFERENCE: { value: 'TELECONFERENCE', title: '电话会议' },
  EMU: { value: 'EMU', title: 'EMU' },
  CMU: { value: 'CMU', title: 'CMU' },
};

/** 料号类型 */
export const MATERIAL_TYPE = {
  /** 成品料号 */
  FINISHED: { value: "FINISHED", text: '成品料号' },
  /** 物料料号 */
  SUPPLIER: { value: "SUPPLIER", text: '物料料号' },
};
